import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '公司名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'taxId',
    fieldName: '税号'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'taxRate',
    fieldName: '税率',
    formatType: 'percent'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'maxValueSingleInvoice',
    fieldName: '最大金额'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'registeredAddress',
    fieldName: '注册地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'officeAddress',
    fieldName: '办公地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'bank',
    fieldName: '开户银行'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '账号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '电话号码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'bankCode',
    fieldName: '银行行号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fax',
    fieldName: '公司传真'
  }
]
